"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingPrivKeyArgumentException = exports.PrivKeyFormatException = void 0;
class PrivKeyFormatException extends Error {
    constructor(privKey) {
        super(`Invalid key length. Expected 32, but got ${privKey.length}`);
    }
}
exports.PrivKeyFormatException = PrivKeyFormatException;
class MissingPrivKeyArgumentException extends Error {
    constructor() {
        super(`Missing argument privKey`);
    }
}
exports.MissingPrivKeyArgumentException = MissingPrivKeyArgumentException;
//# sourceMappingURL=errors.js.map